import { render, staticRenderFns } from "./ReportFactControl.vue?vue&type=template&id=34ac234a&scoped=true"
import script from "./ReportFactControl.vue?vue&type=script&lang=js"
export * from "./ReportFactControl.vue?vue&type=script&lang=js"
import style0 from "./ReportFactControl.vue?vue&type=style&index=0&id=34ac234a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ac234a",
  null
  
)

export default component.exports